import React from "react";
import { motion } from "framer-motion";
import "./Milestones.css";

// Import all 5 SVGs
import award1 from "./../../src/assets/medal.svg"
import award2 from "./../../src/assets/rewards.svg"
import award3 from "./../../src/assets/star.svg"
import award4 from "./../../src/assets/trophy.svg"
import award5 from "./../../src/assets/gold-medal.svg"

const achievements = [
  {
    title: "First Aadhaar-Linked Wallet",
    description: "First Company in India to launch Aadhaar linked wallet",
    tag: "Milestone",
    tagColor: "#42a073ff",
    icon: award1,
  },
  {
    title: "State Co-branded Digital Wallet",
    description: "Launched First State Co-branded Digital Wallet",
    tag: "Milestone",
    tagColor: "#42a073ff",
    icon: award2,
  },
  {
    title: "PSU Wallet",
    description: "Launched First PSU Wallet in partnership",
    tag: "Milestone",
    tagColor: "#42a073ff",
    icon: award3,
  },
  {
    title: "Smart Banking Integration",
    description: "First Company in India to provide smart card linked to regular Banking System",
    tag: "Achievement",
    tagColor: "#42a073ff",
    icon: award4,
  },
  {
    title: "Global Recognition",
    description: "BAI (USA) Finalist in Global Innovative Awards In Payments",
    tag: "Achievement",
    tagColor: "#42a073ff",
    icon: award5,
  },
];

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.95 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const Milestones = () => {
  return (
    <motion.section
      className="milestones-section"
      variants={containerVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.2 }}
    >
      <motion.div
        className="milestones-header"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <h2>Achievements & Milestones</h2>
        <p>Sneak peek of Our Success Story</p>
      </motion.div>

      <div className="milestones-grid">
        {achievements.map((item, idx) => (
          <motion.div
            key={idx}
            className={`milestone-card ${idx < 3 ? "col-3" : "col-4"}`}
            style={{ borderColor: item.tagColor }}
            variants={cardVariants}
            whileHover={{
              scale: 1.05,
              transition: { duration: 0.3 },
            }}
          >
            <div className="milestone-icon">
              <img
                src={item.icon}
                alt={`Icon for ${item.title}`}
                style={{ width: "50px", height: "50px" }}
              />
            </div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            <span style={{ color: item.tagColor }}>↗ {item.tag}</span>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default Milestones;
